import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Table,
  Button,
  Heading
} from 'monday-ui-react-core';
import { Download } from 'monday-ui-react-core/icons';
import waveClient from '../../services/wave/waveClient';
import { formatCurrency } from '../../utils/formatters';
import Loading from '../common/Loading';

function ProfitLossReport({ filters }) {
  const [data, setData] = useState({
    revenue: { total: 0, items: [] },
    expenses: { total: 0, items: [] },
    netIncome: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (filters.businessId) {
      loadReport();
    }
  }, [filters]);

  const loadReport = async () => {
    try {
      setLoading(true);
      const reportData = await waveClient.getProfitLossReport(filters);
      setData({
        revenue: reportData?.business?.profitAndLoss?.revenue || { total: 0, items: [] },
        expenses: reportData?.business?.profitAndLoss?.expenses || { total: 0, items: [] },
        netIncome: reportData?.business?.profitAndLoss?.netIncome || 0
      });
    } catch (error) {
      console.error('Error loading P&L report:', error);
      setData({
        revenue: { total: 0, items: [] },
        expenses: { total: 0, items: [] },
        netIncome: 0
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <Box className="profit-loss-report">
      <Box className="report-actions" marginBottom={16}>
        <Button leftIcon={Download}>Export Report</Button>
      </Box>

      <Table>
        <Table.Header>
          <Table.HeaderCell>Category</Table.HeaderCell>
          <Table.HeaderCell>Amount</Table.HeaderCell>
          <Table.HeaderCell>% of Revenue</Table.HeaderCell>
        </Table.Header>
        <Table.Body>
          {/* Revenue Section */}
          <Table.Row>
            <Table.Cell>
              <Heading type={Heading.types.h5}>Revenue</Heading>
            </Table.Cell>
            <Table.Cell>{formatCurrency(data.revenue.total)}</Table.Cell>
            <Table.Cell>100%</Table.Cell>
          </Table.Row>
          {(data.revenue.items || []).map((item, index) => (
            <Table.Row key={`revenue-${index}`}>
              <Table.Cell>{item.category}</Table.Cell>
              <Table.Cell>{formatCurrency(item.amount)}</Table.Cell>
              <Table.Cell>
                {((item.amount / data.revenue.total) * 100).toFixed(1)}%
              </Table.Cell>
            </Table.Row>
          ))}

          {/* Expenses Section */}
          <Table.Row>
            <Table.Cell>
              <Heading type={Heading.types.h5}>Expenses</Heading>
            </Table.Cell>
            <Table.Cell>{formatCurrency(data.expenses.total)}</Table.Cell>
            <Table.Cell>
              {((data.expenses.total / data.revenue.total) * 100).toFixed(1)}%
            </Table.Cell>
          </Table.Row>
          {(data.expenses.items || []).map((item, index) => (
            <Table.Row key={`expense-${index}`}>
              <Table.Cell>{item.category}</Table.Cell>
              <Table.Cell>{formatCurrency(item.amount)}</Table.Cell>
              <Table.Cell>
                {((item.amount / data.revenue.total) * 100).toFixed(1)}%
              </Table.Cell>
            </Table.Row>
          ))}

          {/* Net Income */}
          <Table.Row>
            <Table.Cell>
              <Heading type={Heading.types.h5}>Net Income</Heading>
            </Table.Cell>
            <Table.Cell>{formatCurrency(data.netIncome)}</Table.Cell>
            <Table.Cell>
              {((data.netIncome / data.revenue.total) * 100).toFixed(1)}%
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Box>
  );
}

export default ProfitLossReport; 